/**
 * Days of history to load by default when no narrowing filters are applied.
 * Appears in productIndex.tsx and productFilter.tsx — change here to update both.
 */
export const PRODUCTS_DEFAULT_WINDOW_DAYS = 90

/**
 * Query-string keys that represent pagination / sort controls rather than
 * user-supplied narrowing filters. A query that contains ONLY these keys (with
 * no other non-empty values) is considered "un-filtered" and the default date
 * window will be injected automatically.
 *
 * Note: `productPackage` is intentionally NOT listed here. A user who changes
 * the status filter away from the default set IS applying a narrowing filter
 * and should receive results from the full database — not just the last
 * PRODUCTS_DEFAULT_WINDOW_DAYS days.
 */
export const PAGINATION_KEYS = new Set([
  'offset',
  'limit',
  'sort',
  'direction',
])

/**
 * Returns true when `parsedQuery` contains at least one key that represents a
 * genuine user-applied narrowing filter (i.e. any key outside PAGINATION_KEYS
 * that has a non-empty value).
 */
export const hasNarrowingFilters = (
  parsedQuery: Record<string, any>
): boolean => {
  return Object.keys(parsedQuery).some((key) => {
    if (PAGINATION_KEYS.has(key)) return false
    const val = parsedQuery[key]
    if (val == null || val === '') return false
    if (Array.isArray(val) && val.length === 0) return false
    return true
  })
}
